var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-guide-mobile"},[(_vm.guideContent)?void 0:_c('p',{staticClass:"font-size-18 secondary-color-txt text-center"},[_vm._v("Nội dung đang cập nhật!")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }